export class RoutesNotDefinedError extends Error {
  constructor() {
    super('Routes are not defined. Is the component inside a <RoutesContext.Provider>?');
  }
}
